import { render, staticRenderFns } from "./LocationDevicesList.vue?vue&type=template&id=16a504b4&scoped=true"
import script from "./LocationDevicesList.vue?vue&type=script&lang=js"
export * from "./LocationDevicesList.vue?vue&type=script&lang=js"
import style0 from "./LocationDevicesList.vue?vue&type=style&index=0&id=16a504b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16a504b4",
  null
  
)

export default component.exports